import { render, staticRenderFns } from "./SkupForma.vue?vue&type=template&id=515846a0&scoped=true&"
import script from "./SkupForma.vue?vue&type=script&lang=js&"
export * from "./SkupForma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515846a0",
  null
  
)

export default component.exports